import { Navigate, Outlet } from "react-router-dom";
import { trpc } from "../lib/trpc";

/**
 * Auth guard: trpc.auth.me ile session doğrula.
 * - yükleniyor → boş ekran (skeleton later)
 * - user yok → /login'e yönlendir
 * - user var → child route render
 */
export function ProtectedRoute() {
  const meQ = trpc.auth.me.useQuery(undefined, {
    retry: false,
    staleTime: 60_000,
  });

  if (meQ.isLoading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100dvh" }}>
        <span style={{ fontSize: 13, color: "var(--neutral-500)" }}>Yükleniyor…</span>
      </div>
    );
  }

  if (!meQ.data?.user) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
